<template>
  <div class="login">
    <div class="main b-flex b-justify-center b-align-centenr">
      <div class="main-box b-flex">
        <div class="main-left b-flex b-align-end b-flex-column">
          <h2>商务出行就用差旅管家</h2>
          <h5>
            奖励您的出行
            聪明您的管理
          </h5>
        </div>
        <div class="main-right">
          <h4>会员登录</h4>
          <div>
            <div class="input-list">
              <el-input
                placeholder="请输入手机号"
                @blur="checkInput(1)"
                @focus="focusInput(1)"
                v-model="phone"
                clearable
                maxlength="11"
              ></el-input>
              <p v-if="isShowPhoneTip">请正确输入您的手机号</p>
            </div>
            <div class="input-list">
              <el-input
                placeholder="请输入密码"
                type="password"
                @blur="checkInput(2)"
                @focus="focusInput(2)"
                v-model="password"
                clearable
              ></el-input>
              <p v-if="isShowPsdTip">请正确输入您的密码</p>
            </div>
            <div class="auto-login b-flex b-flex-bettwen">
              <div>
                <!--<el-checkbox v-model="checked"></el-checkbox> 30天内自动登录-->
              </div>
              <!--<div class="forget-psd" @click="goResetPsd">忘记密码？</div>-->
            </div>
            <div class="login-btn" @click="login">登录</div>
            <div class="apply" @click="goRegister">
              还没申请差旅管家账号？
              <span>立即体验</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <topleft></topleft>
  </div>
</template>

<script>
import topleft from "@/components/left"
export default {
  components: {
    topleft
  },
  data() {
    return {
      isShowPhoneTip: false,
      isShowPsdTip:false,
      phone: "",
      password: ""
    };
  },
  mounted() {},
  methods: {
    //验证账户和密码  1.手机号  2.密码
    checkInput(type) {
      if (type == 1) {
        if (!this.$commonFun.checkPhone(this.phone)) {
          this.isShowPhoneTip = true;
        } else {
          this.isShowPhoneTip = false;
        }
      } else if (type == 2) {
        if (!this.password) {
          this.isShowPsdTip = true;
        } else {
          this.isShowPsdTip = false;
        }
      }
    },
    //获取焦点
    focusInput(type) {
      if (type == 1) {
        this.isShowPhoneTip = false;
      } else if (type == 2) {
        this.isShowPsdTip = false;
      }
    },
    login() {
      let param = {
        phone: this.phone,
        password: this.password,
        type: 2,
        code: "",
        Version: "5.4.0",
        PlatId: 1003
      };
      if (this.isShowPhoneTip || !this.phone) {
        this.$message.error("请正确输入您的手机号");
        return;
      }
      if (!this.password) {
        this.$message.error("请正确输入您的密码");
        return;
      }
      this.$api.login(param).then(res => {
        if (res.Code == "0000") {
          if (res.Customers && res.Customers.length >= 1) {
              window.location.href = "https://www.ceekee.com?memberId=" + res.Customers[0].MemberId +"&token=" + res.Customers[0].Token +"&isManage=" + res.Customers[0].IsManager;
          }
        } else {
          this.$commonFun.toast(res.Msg);
        }
      });
    },
    goRegister() {
      window.location.href = "http://" + window.location.host + "/sign/sign"
    }
  }
};
</script>

<style scoped>
.apilist {
  padding-left: 17px;
}
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.login {
  width: 100%;
}
.header {
  min-width: 1200px;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0 10%;
  z-index: 100;
  background: rgba(72, 79, 92, 0.5);
  box-sizing: border-box;
  height: 80px;
}
.nav {
  width: 50%;
}
.nav-list {
  width: 25%;
  cursor: pointer;
  color: #fff;
  text-align: center;
}
.nav-list:last-child a {
  border: none;
}
.nav-list a {
  display: block;
  border-right: 1px solid #fff;
  height: 10px;
  line-height: 10px;
  font-size: 16px;
}
.nav-list a:hover {
  color: #328bef;
}

.main {
  width: 100%;
  min-width: 1200px;
  min-height: 100vh;
  background: url("../assets/image/login-bg.jpg") no-repeat center center;
  background-size: 100% 100%;
  padding: 80px 0 150px;
  box-sizing: border-box;
}

.main-left {
  color: #fff!important;
  padding-right: 40px;
  box-sizing: border-box;
}
.main-right {
  background: rgba(234, 236, 238, 0.9);
  margin-left: 40px;
  padding: 20px 60px;
  width: 400px;
  box-sizing: border-box;
  border-radius: 3px;
}
.main-left h2 {
  font-size: 50px;
  font-weight: normal;
  line-height: 100px;
  height: 100px;
  color: #fff!important;
}
.main-left h5 {
  font-size: 26px;
  font-weight: normal;
  height: 60px;
  line-height: 60px;
  margin-bottom: 30px;
  color: #fff!important;
}
.main-left h5 span {
  border-bottom: 4px solid #fff;
  padding-bottom: 10px;
}
.downLoad img {
  width: 155px;
}
.downLoad p {
  font-size: 12px;
}
.main-right h4 {
  color: #333;
  font-size: 22px;
  font-weight: 500;
  text-align: center;
  line-height: 40px;
  margin-bottom: 10px;
}
.input-list {
  position: relative;
  margin-bottom: 20px;
}
.input-list p {
  position: absolute;
  bottom: -17px;
  font-size: 12px;
  color: #ff4c4c;
  padding-left: 5px;
}
.login-btn {
  width: 100%;
  height: 45px;
  line-height: 45px;
  background: #328bef;
  font-size: 16px;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 15px;
}
.auto-login {
  margin-bottom: 15px;
}
.forget-psd {
  color: #328bef;
  cursor: pointer;
}
.apply {
  font-size: 12px;
  color: #333;
  text-align: right;
  cursor: pointer;
}
.apply span {
  color: #333;
  border-bottom: 1px solid #333;
}
.apply span:hover {
  color: #328bef;
  border-color: #328bef;
}
</style>